import React, { useEffect } from "react";
import styled, { useTheme } from "styled-components";
import { useTranslate } from "@tolgee/react";
import { ReactComponent as ConferenceIcon } from "../../Assets/iconsv2/sidebar/SpeakerFilled.svg";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import { useAuthService } from "../../Context/AuthContext";
import ConferenceList from "./ConferenceList";
import ConferenceDetailsCard from "./ConferenceDetailsCard";
import AddNewConferenceModal from "./AddNewConferenceModal";
import IconButton from "../GenericComponents/IconButton";

const Conferences = ({
  conferences,
  handleJoinConference,
  handleSelectConference,
  loadConferences,
  selectedConference,
  handleCloseConferenceDetails,
  handleDeleteConferenceBtn,
  handleUpdateConferenceDetails,
  contacts,
}) => {
  const {
    isMeetingDetailsOpen,
    setIsAddNewMeetingOpen,
    isAddNewMeetingOpen,
    setIsMeetingDetailsOpen,
  } = useGenericComponentsStateService();
  const { platformConferences } = useAuthService();
  const conferencesEnabled = platformConferences?.enabled === true;
  const theme = useTheme();
  const { t } = useTranslate();

  const handleOpenAddNewConference = () => {
    setIsAddNewMeetingOpen(true);
    setIsMeetingDetailsOpen(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      loadConferences();
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, [loadConferences]);

  return (
    <Container>
      <Main>
        <Header>
          <HeaderTitle>
            {t("general.conferences")}
          </HeaderTitle>
          {conferencesEnabled && (
            <IconButton
              icon={<ConferenceIcon />}
              onClick={() => handleOpenAddNewConference()}
            />
          )}
        </Header>
        <ConferenceList
          conferences={conferences}
          handleJoinConference={handleJoinConference}
          handleSelectConference={handleSelectConference}
          loadConferences={loadConferences}
          selectedConference={selectedConference}
        />
      </Main>
      <Details>
        {!isMeetingDetailsOpen && !isAddNewMeetingOpen && conferencesEnabled && (
          <StartCallWrapper>
            <IconButton
              onClick={() => handleOpenAddNewConference()}
              style={{
                background: theme.chat.selectedBackground,
                padding: "10px",
                borderRadius: "4px",
              }}
              icon={<ConferenceIcon />}
            />
            <p>
              {t("conferences.create_a_conference")}
            </p>
          </StartCallWrapper>
        )}

        {isMeetingDetailsOpen && (
          <ConferenceDetailsCard
            conference={selectedConference}
            handleCloseConferenceDetails={handleCloseConferenceDetails}
            handleDeleteConferenceBtn={handleDeleteConferenceBtn}
            handleUpdateConferenceDetails={handleUpdateConferenceDetails}
            contacts={contacts}
            handleJoinConference={handleJoinConference}
          />
        )}
        {isAddNewMeetingOpen && (
          <AddNewConferenceModal
            contacts={contacts}
            loadConferences={loadConferences}
          />
        )}
      </Details>
    </Container>
  );
};

export default Conferences;

const Container = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 419px;
  width: 100%;
  background: ${({ theme }) => theme.menu.background};
  border-right: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 19px 16px;
  align-items: center;
  background: ${({ theme }) => theme.menu.background};
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 20px;
`;
const HeaderTitle = styled.h3`
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.04px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
`;
const Details = styled.div`
  width: 100%;
  display: flex;
  background: ${({ theme }) => theme.menu.background};
`;

const StartCallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  margin: auto;
  color: ${({ theme }) => theme.menu.selectedTextColor};
`;
